import React from 'react';
import { FormContainerModifier, FormContext } from '../../molecules/Form';
import Form from '../../molecules/Form/Form';
import FormSubmitOrCancel from '../../molecules/Form/components/FormSubmitOrCancel/FormSubmitOrCancel';
import LiveRegion from '../../atoms/LiveRegion/LiveRegion';
import FormModel from '../../molecules/Form/models/FormModel';
import IForm from '../../../types/IForm';

type DeletableItemFormProps = {
  id: string;
  model: IForm;
  onSubmit?: (event: Event, model: FormModel) => void;
  onSuccess?: () => void;
  ariaLabel: string;
  cancelAction: () => void;
  customErrorMessages?: any;
};

export default function DeletableItemForm({
  id,
  model,
  onSubmit,
  onSuccess,
  ariaLabel,
  cancelAction,
  customErrorMessages = {},
}: DeletableItemFormProps) {
  return (
    <Form
      id={id}
      model={model}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
      containerModifier={FormContainerModifier.NO_PADDING}
      ariaLabel={ariaLabel}
    >
      <FormContext.Consumer>
        {({ getStatus }: any) => {
          return (
            <>
              <FormSubmitOrCancel focusOnMount hierarchy={4} headline={ariaLabel} cancelAction={cancelAction} />
              <LiveRegion htmlTag="div" invisible={false}>
                {getStatus(customErrorMessages)}
              </LiveRegion>
            </>
          );
        }}
      </FormContext.Consumer>
    </Form>
  );
}
